import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import IndexPage from "./pages/IndexPage";
import DashboardPage from "./pages/DashboardPage";
import FastReplyPage from "./pages/FastReplyPage";
import KnowledgePage from "./pages/knowledge/KnowledgePage";
import PasswordChangePage from "./pages/PasswordChangePage";
import UsersPage from "./modules/users/UsersPage";

const hasLogin = () => {
  const manager = localStorage.getItem("manager");
  const token = localStorage.getItem("token");
  return Boolean(manager && token);
};

const LoginRoute = () => {
  if (hasLogin()) {
    return <Navigate to="/" replace />;
  }
  return <LoginPage />;
};

const ProtectedRoute = () => {
  if (!hasLogin()) {
    return <Navigate to="/login" replace />;
  }
  return <IndexPage />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="fast-reply" element={<FastReplyPage />} />
          <Route path="knowledge" element={<KnowledgePage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="password/change" element={<PasswordChangePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
